/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_FeedbackInputs */

const cs_viewings_feedback = /** @type {(inputs: Viewings_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpětná vazba`)
};

const en_viewings_feedback = /** @type {(inputs: Viewings_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Viewings_FeedbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_feedback = /** @type {((inputs?: Viewings_FeedbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_FeedbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_feedback(inputs)
	return cs_viewings_feedback(inputs)
});